/* ModalShare.js */

import React, { useCallback } from 'react';
import { Modal, ModalBody, ModalHeader } from 'reactstrap';
import RemixPlugin from '../remix/RemixPlugin';
import RemixShare from '../remix/RemixShare';

export default function ModalShare({open, setOpen, remix}) {
  const toggle = useCallback(() => setOpen(!open), [open, setOpen]);

  return (
    <Modal isOpen={open} toggle={toggle} size='lg'>
      <ModalHeader toggle={toggle} className='text-crop-container'>
        <div className='text-crop'>
          {remix && remix.rti}
        </div>
      </ModalHeader>
      <ModalBody className='text-center'>
        <div className='mb-4'>
          <RemixPlugin remix={remix} />
        </div>
        <div className='mb-3'>
          <RemixShare remix={remix} />
        </div>
      </ModalBody>
    </Modal>
  );
}
